import requests from "./httpService";
import secureLocalStorage from "react-secure-storage";

const LoginService = {
  loginAdmin(body) {
    return requests.post(`/user/login`, body);
  },
  initialPasswordReset(body) {
    return requests.post(`/user/initial-password-reset`, body);
  },
  logout() {
    secureLocalStorage.clear();
  }
};

export default LoginService;
